import { DialogProps } from "@mui/material";
import { keyModal, useStore } from "hooks/useStore";
import React, { useEffect } from "react";

interface StoreValues {
  content: React.ReactNode;
  modalProps: Partial<DialogProps>;
  setValue: (key: keyof StoreValues, value: unknown) => void;
}

export default function useGlobalModal() {
  const { content, modalProps, setValue } = useStore(
    (store) => store[keyModal],
  ) as StoreValues;

  useEffect(() => {
    setValue("modalProps", undefined);
  }, []);

  function setModalContent(
    children?: React.ReactNode,
    modalProps?: Partial<DialogProps>,
  ) {
    setValue("content", children);
    if (modalProps) {
      setValue("modalProps", modalProps);
    }
  }

  return {
    content,
    modalProps,
    setModalContent,
  };
}
